const defaultTheme = {
    colors: {
        background: '#F6F5FC',
        primary: {
            light: '#5E81AC',
            main: '#3B5998', // Trustworthy Blue
            dark: '#2E4374',
        },
        secondary: {
            main: '#FF6B6B', // Accent
        },
        danger: {
            light: '#FEE2E2',
            main: '#FC5050',
            dark: '#B91C1C',
        },
        warning: {
            light: '#FFFBEB',
            main: '#D97706',
            dark: '#92400E',
        },
        success: {
            light: '#F0FDF4',
            main: '#16A34A',
            dark: '#15803D',
        },
        info: {
            light: '#EFF6FF',
            main: '#2563EB',
            dark: '#1D4ED8',
        },
        indigo: {
            light: '#EEF2FF',
            main: '#6366F1',
            dark: '#4338CA',
        },
        teal: {
            light: '#F0FDFA',
            main: '#14B8A6',
            dark: '#0F766E',
        },
        orange: {
            light: '#FFF7ED',
            main: '#F97316',
            dark: '#C2410C',
        },
        gray: {
            900: '#222222',
            700: '#4B5563',
            500: '#6B7280',
            200: '#BCBCBC',
            100: '#E6E6E6',
        },
    },
};

export default defaultTheme;
